<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00004 10.6667C1.00004 11.4 1.60004 12 2.33337 12H7.66671C8.40004 12 9.00004 11.4 9.00004 10.6667V2.66667H1.00004V10.6667ZM9.66671 0.666667H7.33337L6.66671 0H3.33337L2.66671 0.666667H0.333374V2H9.66671V0.666667Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#66B015'
    },
    width: {
      type: String,
      default: '10'
    },
    height: {
      type: String,
      default: '12'
    }
  },
  computed: {
    viewbox() {
      return `0 0 25 25`
    }
  }
}
</script>
